webpackJsonp([0],[
/* 0 */,
/* 1 */,
/* 2 */,
/* 3 */,
/* 4 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(21)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(14),
  /* template */
  __webpack_require__(39),
  /* scopeId */
  "data-v-96da4ba4",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 5 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_firebase__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_firebase___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_firebase__);


var config = {
  apiKey: 'AIzaSyBEgaTGYQOUcf_1rYm3GjBOt4fqkTbpXNA',
  authDomain: 'inverse-cb4f5.firebaseapp.com',
  databaseURL: 'https://inverse-cb4f5.firebaseio.com',
  storageBucket: 'inverse-cb4f5.appspot.com',
  messagingSenderId: '715071482302'
};
__WEBPACK_IMPORTED_MODULE_0_firebase___default.a.initializeApp(config);

var VueFirebase = {
  install: function install(Vue, options) {
    Vue.prototype.$firebase = __WEBPACK_IMPORTED_MODULE_0_firebase___default.a;
  }
};
/* harmony default export */ __webpack_exports__["a"] = (VueFirebase);

/***/ }),
/* 6 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_router__ = __webpack_require__(41);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_Menu__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_Menu___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__components_Menu__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_Settings__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_Settings___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__components_Settings__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_Game__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_Game___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__components_Game__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_Score__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_Score___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__components_Score__);







__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]);

/* harmony default export */ __webpack_exports__["a"] = (new __WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]({
  routes: [{
    path: '/',
    name: 'Menu',
    component: __WEBPACK_IMPORTED_MODULE_2__components_Menu___default.a
  }, {
    path: '/settings',
    name: 'Settings',
    component: __WEBPACK_IMPORTED_MODULE_3__components_Settings___default.a
  }, {
    path: '/game',
    name: 'Game',
    component: __WEBPACK_IMPORTED_MODULE_4__components_Game___default.a
  }, {
    path: '/score',
    name: 'Score',
    component: __WEBPACK_IMPORTED_MODULE_5__components_Score___default.a
  }]
}));

/***/ }),
/* 7 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(18)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(9),
  /* template */
  __webpack_require__(36),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 8 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__App__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__App___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__App__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__router__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__plugin_vue_firebase__ = __webpack_require__(5);







__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_3__plugin_vue_firebase__["a" /* default */]);

new __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */]({
  el: '#app',
  router: __WEBPACK_IMPORTED_MODULE_2__router__["a" /* default */],
  template: '<App/>',
  components: {
    App: __WEBPACK_IMPORTED_MODULE_1__App___default.a
  },
  watch: {
    '$route': function $route(to, from) {
      if (window.ga) {
        window.ga('set', 'page', to.path);
        window.ga('send', 'pageview');
      }
    }
  }
});

if (!localStorage.font) {
  localStorage.setItem('font', 'monospace');
}
if (!localStorage.highest) {
  localStorage.setItem('highest', 0);
}
if (!localStorage.name) {
  localStorage.setItem('name', 'Anonymous');
}
if (!localStorage.lastSubmitScore) {
  localStorage.setItem('lastSubmitScore', 0);
}
if (!localStorage.last) {
  localStorage.setItem('last', 0);
}
if (!localStorage.mode) {
  localStorage.setItem('mode', '0');
}
if (!localStorage.timelimit) {
  localStorage.setItem('timelimit', 4);
}

if (!localStorage.tutorial) {
  localStorage.setItem('tutorial', 1);
}

/***/ }),
/* 9 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'app',
  mounted: function mounted() {
    var _this = this;

    var titles = document.querySelectorAll('.tlt > span');
    setTimeout(function () {
      return _this.changeTlt(titles);
    }, 1000);
    setInterval(function () {
      return _this.changeTlt(titles);
    }, 4000);
  },

  computed: {
    isHomePage: function isHomePage() {
      return this.$route.name === 'Menu';
    }
  },
  methods: {
    changeTlt: function changeTlt(titles) {
      var count = 500;
      titles.forEach(function (ele) {
        setTimeout(function () {
          if (ele.className === 'rotateY180') {
            ele.className = '';
          } else {
            ele.className = 'rotateY180';
          }
        }, count += 150);
      });
    }
  }
});

/***/ }),
/* 10 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Timer__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Timer___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__Timer__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Tutorial__ = __webpack_require__(33);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Tutorial___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__Tutorial__);





var possible = 'abcdefghijklmnopqrstuvwxyz';
/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'game',
  data: function data() {
    return {
      count: 0,
      highest: localStorage.highest,
      numOfchoices: 3,
      words: [],
      topic: {},
      isTutorial: localStorage.tutorial === '1',
      tutorialTopic: {},
      stage: 'ready',
      message: '',
      readyTime: 3,
      timeLimit: this.readyTime,
      font: localStorage.font,
      lock: false,
      name: localStorage.name,
      submited: false
    };
  },

  components: {
    'timer': __WEBPACK_IMPORTED_MODULE_0__Timer___default.a,
    'tutorial': __WEBPACK_IMPORTED_MODULE_1__Tutorial___default.a
  },
  created: function created() {
    this.$firebase.auth().signInAnonymously().catch(function (error) {
      var errorCode = error.code;
      var errorMessage = error.message;

      console.error('Error ' + errorCode + ': ' + errorMessage);
    });
  },
  mounted: function mounted() {
    var _this = this;

    fetch('./static/words.json').then(function (response) {
      return response.json();
    }).then(function (json) {
      _this.words = _this.shuffle(json.words);
      if (_this.isTutorial) {
        _this.tutorialTopic = _this.getTopic();
      } else {
        _this.ready();
      }
    });
  },

  computed: {
    isPlaying: function isPlaying() {
      return this.stage === 'playing';
    },
    isGameOver: function isGameOver() {
      return this.stage === 'gameover';
    },
    isReady: function isReady() {
      return this.stage === 'ready';
    }
  },
  methods: {
    ready: function ready() {
      this.submited = false;
      this.stage = 'ready';
      this.message = 'Ready';
      this.timeLimit = this.readyTime;
      this.count = 0;
      this.$refs.timer.start();
    },
    start: function start() {
      this.lock = false;
      this.stage = 'playing';
      this.message = '';
      this.timeLimit = localStorage.timelimit;
      this.next();
    },
    next: function next() {
      this.$refs.timer.stop();
      this.$refs.timer.reset();
      this.topic = this.getTopic();
      this.$refs.timer.start();
      this.lock = false;
    },
    gameOver: function gameOver() {
      this.stage = 'gameover';
      this.message = 'Game Over';
    },
    replay: function replay() {
      this.ready();
    },
    oneMoreTutorial: function oneMoreTutorial() {
      this.tutorialTopic = this.getTopic();
    },
    finishTutorial: function finishTutorial() {
      this.isTutorial = false;
      this.ready();
    },
    timeout: function timeout() {
      switch (this.stage) {
        case 'ready':
          this.start();
          break;
        case 'playing':
          this.gameOver();
          break;
      }
    },
    getTopic: function getTopic() {
      var word = this.words.shift();
      var choices = this.genChoices(word);
      return {
        question: word,
        choices: choices
      };
    },
    checkAnswer: function checkAnswer(choice) {
      if (this.lock) {
        return;
      }
      this.lock = true;
      if (this.topic.question === choice) {
        this.count++;
        this.next();
      } else {
        this.$refs.timer.stop();
        this.gameOver();
      }
      if (this.count > parseInt(localStorage.highest)) {
        this.highest = this.count;
        localStorage.highest = this.highest;
      }
    },
    isCorrect: function isCorrect(word) {
      return this.topic.question === word;
    },
    genChoices: function genChoices(word) {
      var choices = [];
      for (var i = 0; i < this.numOfchoices; i++) {
        choices.push(word);
      }
      for (var j = 0; j < this.numOfchoices - 1; j++) {
        var index = Math.floor(Math.random() * this.numOfchoices);
        choices[index] = this.randomReplace(word);
      }
      return choices;
    },
    randomReplace: function randomReplace(word) {
      var char = '';
      var index = Math.floor(Math.random() * word.length);
      char += possible.charAt(Math.floor(Math.random() * possible.length));
      word = word.substr(0, index) + char + word.substr(index + 1);
      return word;
    },
    shuffle: function shuffle(array) {
      var currentIndex = array.length;
      var temporaryValue = void 0;
      var randomIndex = void 0;

      while (currentIndex !== 0) {
        randomIndex = Math.floor(Math.random() * currentIndex);
        currentIndex -= 1;

        temporaryValue = array[currentIndex];
        array[currentIndex] = array[randomIndex];
        array[randomIndex] = temporaryValue;
      }
      return array;
    },
    send: function send() {
      var _this2 = this;

      if (this.sending) {
        return;
      }
      this.sending = true;
      var leaderboard = this.$firebase.database().ref('leaderboard').push();
      var currentdate = new Date().toISOString();
      localStorage.lastSubmitScore = parseInt(this.count);
      leaderboard.set({
        name: this.name,
        score: parseInt(this.count),
        time: currentdate
      }).then(function () {
        _this2.message = 'submited';
        _this2.submited = true;
        _this2.sending = false;
      });
    }
  }
});

/***/ }),
/* 11 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'settings'
});

/***/ }),
/* 12 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'score',
  data: function data() {
    return {
      leaders: [],
      loading: true,
      message: 'Your highest Score: ' + localStorage.highest
    };
  },
  created: function created() {
    var _this = this;

    this.ref = this.$firebase.database().ref('leaderboard');
    this.ref.orderByChild('score').limitToLast(50).on('value', function (snapshot) {
      var leaders = [];
      snapshot.forEach(function (childSnapshot) {
        leaders.unshift(childSnapshot.val());
      });
      _this.leaders = leaders;
      _this.loading = false;
    });
  },
  destroyed: function destroyed() {
    this.ref.off();
  }
});

/***/ }),
/* 13 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'settings',
  data: function data() {
    return {
      limit: localStorage.timelimit,
      fonts: ['monospace', "'Indie Flower', cursive", "'Molle', cursive", "'Yellowtail', cursive"],
      modes: ['One Chance'],
      selectedMode: parseInt(localStorage.mode),
      selectedFont: localStorage.font
    };
  },

  methods: {
    changeMode: function changeMode(modeIndex) {
      localStorage.mode = modeIndex;
      this.selectedMode = modeIndex;
    },
    changeFont: function changeFont(font) {
      localStorage.font = font;
      this.selectedFont = font;
    },
    changeLimit: function changeLimit() {
      localStorage.timelimit = this.limit;
    }
  }
});

/***/ }),
/* 14 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'timer',
  props: ['limit'],
  data: function data() {
    return {
      time: this.limit
    };
  },
  beforeDestroy: function beforeDestroy() {
    this.stop();
  },

  methods: {
    start: function start() {
      var _this = this;

      this.interval = setInterval(function () {
        _this.time -= 1;
        if (_this.time === 0) {
          _this.stop();
          _this.$emit('timeout');
        }
      }, 1000);
    },
    reset: function reset() {
      this.time = this.limit;
    },
    stop: function stop() {
      if (this.interval != null) {
        clearInterval(this.interval);
      }
    }
  },
  watch: {
    limit: function limit(val) {
      this.reset();
    }
  }
});

/***/ }),
/* 15 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Timer__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Timer___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__Timer__);



/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'tutorial',
  props: ['topic'],
  data: function data() {
    return {
      message: 'Find the inverse of below word',
      withTImer: false,
      stage: 1,
      finish: false,
      font: localStorage.font,
      lock: false
    };
  },


  components: {
    'timer': __WEBPACK_IMPORTED_MODULE_0__Timer___default.a
  },
  created: function created() {},
  mounted: function mounted() {},

  methods: {
    step1: function step1() {
      this.$emit('onemore');
      this.lock = false;
    },
    step2: function step2() {
      this.$refs.timer.stop();
      this.stage = 2;
      this.$emit('onemore');
      this.withTImer = true;
      this.$refs.timer.reset();
      this.$refs.timer.start();
      this.lock = false;
    },
    step3: function step3() {
      var _this = this;

      this.message = 'Exellent!! Lets Begin.';
      localStorage.tutorial = 0;
      setTimeout(function () {
        _this.$emit('finish');
      }, 1500);
    },
    timeout: function timeout() {
      this.message = 'Oh! Timeout. Try again';
      this.step2();
    },
    checkAnswer: function checkAnswer(choice) {
      if (this.lock) {
        return;
      }
      this.lock = true;
      if (this.topic.question === choice) {
        switch (this.stage) {
          case 1:
            this.message = 'Well Done! Lets try with time limt';
            this.step2();
            break;
          case 2:
            this.$refs.timer.stop();
            this.step3();
            break;
        }
      } else {
        this.message = 'Oh! Wrong Try again';
        switch (this.stage) {
          case 1:
            this.step1();
            break;
          case 2:
            this.step2();
            break;
        }
      }
    },
    isCorrect: function isCorrect(word) {
      return this.topic.question === word;
    }
  },
  watch: {
    topic: function topic(val) {}
  }
});

/***/ }),
/* 16 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 17 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 18 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 19 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 20 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 21 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 22 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 23 */,
/* 24 */,
/* 25 */,
/* 26 */,
/* 27 */,
/* 28 */
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,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"

/***/ }),
/* 29 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(22)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(10),
  /* template */
  __webpack_require__(40),
  /* scopeId */
  "data-v-b71166ce",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 30 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(19)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(11),
  /* template */
  __webpack_require__(37),
  /* scopeId */
  "data-v-2c24d0f4",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 31 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(20)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(12),
  /* template */
  __webpack_require__(38),
  /* scopeId */
  "data-v-304ba2fb",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 32 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(16)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(13),
  /* template */
  __webpack_require__(34),
  /* scopeId */
  "data-v-08f41cca",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 33 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(17)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(15),
  /* template */
  __webpack_require__(35),
  /* scopeId */
  "data-v-0d667685",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 34 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    attrs: {
      "id": "settings"
    }
  }, [_c('h1', [_vm._v("Settings")]), _vm._v(" "), _c('div', [_vm._v("\n    Time Limit:\n    "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.limit),
      expression: "limit"
    }],
    attrs: {
      "type": "number",
      "name": "name"
    },
    domProps: {
      "value": (_vm.limit)
    },
    on: {
      "change": _vm.changeLimit,
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.limit = $event.target.value
      },
      "blur": function($event) {
        _vm.$forceUpdate()
      }
    }
  })]), _vm._v(" "), _c('div', [_c('span', [_vm._v("Select a font to play:")]), _vm._v(" "), _c('ul', _vm._l((_vm.fonts), function(font) {
    return _c('li', {
      class: {
        selected: _vm.selectedFont === font
      },
      on: {
        "click": function($event) {
          _vm.changeFont(font)
        }
      }
    }, [_c('span', {
      staticClass: "middle",
      style: ({
        fontFamily: font
      })
    }, [_vm._v(_vm._s(font))])])
  }))]), _vm._v(" "), _c('div', [_c('span', [_vm._v("Game Mode:")]), _vm._v(" "), _c('ul', _vm._l((_vm.modes), function(mode, index) {
    return _c('li', {
      staticClass: "ripple",
      class: {
        selected: _vm.selectedMode === index
      },
      on: {
        "click": function($event) {
          _vm.changeMode(index)
        }
      }
    }, [_c('span', {
      staticClass: "middle"
    }, [_vm._v(_vm._s(mode))])])
  }))])])
},staticRenderFns: []}

/***/ }),
/* 35 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', [_c('h1', [_vm._v("Tutorial")]), _vm._v(" "), _c('h2', [_vm._v(_vm._s(_vm.message))]), _vm._v(" "), _c('timer', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.withTImer),
      expression: "withTImer"
    }],
    ref: "timer",
    attrs: {
      "limit": "10"
    },
    on: {
      "timeout": _vm.timeout
    }
  }), _vm._v(" "), _c('section', {
    attrs: {
      "id": "playing"
    }
  }, [_c('h1', {
    style: ({
      fontFamily: _vm.font
    }),
    attrs: {
      "id": "question"
    }
  }, [_vm._v(_vm._s(_vm.topic.question))]), _vm._v(" "), _vm._l((_vm.topic.choices), function(choice) {
    return _c('div', {
      staticClass: "choice",
      style: ({
        fontFamily: _vm.font
      }),
      on: {
        "click": function($event) {
          _vm.checkAnswer(choice)
        }
      }
    }, [_c('div', {
      staticClass: "a"
    }, [_vm._v("\n        " + _vm._s(choice) + "\n        ")])])
  })], 2)], 1)
},staticRenderFns: []}

/***/ }),
/* 36 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('main', [_c('h1', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isHomePage),
      expression: "isHomePage"
    }],
    staticClass: "tlt"
  }, [_c('span', [_vm._v("T")]), _c('span', [_vm._v("e")]), _c('span', [_vm._v("x")]), _c('span', [_vm._v("t")]), _vm._v(" "), _c('span', [_vm._v("I")]), _c('span', [_vm._v("n")]), _c('span', [_vm._v("v")]), _c('span', [_vm._v("e")]), _c('span', [_vm._v("r")]), _c('span', [_vm._v("s")]), _c('span', [_vm._v("e")])]), _vm._v(" "), _c('router-view'), _vm._v(" "), (!_vm.isHomePage) ? _c('router-link', {
    attrs: {
      "to": "/"
    }
  }, [_c('div', {
    staticClass: "menu ripple"
  }, [_c('i', {
    staticClass: "material-icons middle"
  }, [_vm._v("subdirectory_arrow_left")]), _vm._v(" "), _c('span', {
    staticClass: "middle"
  }, [_vm._v("Back")])])]) : _vm._e()], 1)
},staticRenderFns: []}

/***/ }),
/* 37 */
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('nav', [_c('router-link', {
    attrs: {
      "to": "game"
    }
  }, [_c('div', {
    staticClass: "menu ripple"
  }, [_c('i', {
    staticClass: "material-icons middle"
  }, [_vm._v("play_arrow")]), _vm._v(" "), _c('span', {
    staticClass: "middle"
  }, [_vm._v("Play")])])]), _vm._v(" "), _c('router-link', {
    attrs: {
      "to": "settings"
    }
  }, [_c('div', {
    staticClass: "menu ripple"
  }, [_c('i', {
    staticClass: "material-icons middle"
  }, [_vm._v("settings")]), _vm._v(" "), _c('span', {
    staticClass: "middle"
  }, [_vm._v("Settings")])])]), _vm._v(" "), _c('router-link', {
    attrs: {
      "to": "score"
    }
  }, [_c('div', {
    staticClass: "menu ripple"
  }, [_c('img', {
    staticClass: "middle",
    attrs: {
      "src": __webpack_require__(28),
      "title": "Leaderboard",
      "width": "28.8"
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "middle"
  }, [_vm._v("Score")])])])], 1)
},staticRenderFns: []}

/***/ }),
/* 38 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', [_c('h1', [_vm._v("Score")]), _vm._v(" "), _c('div', [_vm._v(_vm._s(_vm.message))]), _vm._v(" "), _c('h4', [_vm._v("Top 50")]), _vm._v(" "), _c('ul', [(_vm.loading) ? _c('li', [_vm._v("Loading...")]) : _vm._l((_vm.leaders), function(leader, index) {
    return _c('li', [_c('span', [_vm._v(_vm._s(index + 1) + ". " + _vm._s(leader.name) + "  - " + _vm._s(leader.score))])])
  })], 2)])
},staticRenderFns: []}

/***/ }),
/* 39 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('h1', {
    attrs: {
      "id": "timer"
    }
  }, [_vm._v(_vm._s(_vm.time))])
},staticRenderFns: []}

/***/ }),
/* 40 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isTutorial),
      expression: "isTutorial"
    }]
  }, [_c('tutorial', {
    attrs: {
      "topic": _vm.tutorialTopic
    },
    on: {
      "onemore": _vm.oneMoreTutorial,
      "finish": _vm.finishTutorial
    }
  })], 1), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.isTutorial),
      expression: "!isTutorial"
    }]
  }, [_c('div', {
    staticClass: "counter"
  }, [_c('span', [_vm._v("count: "), _c('span', {
    attrs: {
      "id": "score"
    }
  }, [_vm._v(_vm._s(_vm.count))])]), _vm._v(" "), _c('span', [_vm._v("highest: "), _c('span', {
    attrs: {
      "id": "high_score"
    }
  }, [_vm._v(_vm._s(_vm.highest))])])]), _vm._v(" "), _c('timer', {
    ref: "timer",
    attrs: {
      "limit": _vm.timeLimit
    },
    on: {
      "timeout": _vm.timeout
    }
  }), _vm._v(" "), _c('section', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.isReady),
      expression: "!isReady"
    }],
    attrs: {
      "id": "topic"
    }
  }, [_c('h1', {
    style: ({
      fontFamily: _vm.font
    }),
    attrs: {
      "id": "question"
    }
  }, [_vm._v(_vm._s(_vm.topic.question))]), _vm._v(" "), _vm._l((_vm.topic.choices), function(choice) {
    return _c('div', {
      staticClass: "choice",
      style: ({
        fontFamily: _vm.font
      }),
      on: {
        "click": function($event) {
          _vm.checkAnswer(choice)
        }
      }
    }, [_c('div', {
      class: {
        a: _vm.isPlaying
      }
    }, [_vm._v("\n          " + _vm._s(choice) + "\n          "), _c('span', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (_vm.isGameOver),
        expression: "isGameOver"
      }]
    }, [(_vm.isCorrect(choice)) ? _c('i', {
      staticClass: "material-icons middle green"
    }, [_vm._v("done")]) : _c('i', {
      staticClass: "material-icons middle red"
    }, [_vm._v("clear")])])])])
  })], 2), _vm._v(" "), _c('h1', [_vm._v(_vm._s(_vm.message))]), _vm._v(" "), (_vm.isGameOver && !_vm.submited) ? _c('div', [_vm._v("\n      Name:\n      "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.name),
      expression: "name"
    }],
    attrs: {
      "id": "name",
      "type": "text",
      "name": "name"
    },
    domProps: {
      "value": (_vm.name)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.name = $event.target.value
      }
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "menu ripple middle",
    on: {
      "click": function($event) {
        _vm.send()
      }
    }
  }, [_c('i', {
    staticClass: "material-icons middle"
  }, [_vm._v("send")]), _vm._v(" "), _c('span', {
    staticClass: "middle"
  }, [_vm._v("Send")])])]) : _vm._e(), _vm._v(" "), (_vm.isGameOver) ? _c('div', {
    staticClass: "menu ripple",
    on: {
      "click": _vm.replay
    }
  }, [_c('i', {
    staticClass: "material-icons middle"
  }, [_vm._v("replay")]), _vm._v(" "), _c('span', {
    staticClass: "middle"
  }, [_vm._v("Re-Play")])]) : _vm._e()], 1)])
},staticRenderFns: []}

/***/ })
],[8]);


// WEBPACK FOOTER //
// static/js/app.401292a9620bbdcd9260.js